module.exports = __webpack_public_path__ + "static/media/miner4.db0c55d5.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/Home/components/Miner/miner4.png
// module id = 878
// module chunks = 0